package com.alpha.showcase.common.utils


val SUPPORT_MIME_FILTER_IMAGE = listOf(
    "image/jpeg",
    "image/webp",
    "image/png",
    "image/bmp",
    "image/gif",
    "image/dng",
    "image/heic",
    "image/heif",
    "image/svg+xml",
    "image/x-icon",
)
val SUPPORT_MIME_FILTER_VIDEO = listOf(
    "video/mp4",
    "video/x-matroska",
    "video/webm",
    "video/quicktime",
    "video/x-msvideo",
    "video/x-ms-wmv",
    "video/x-flv",
    "video/x-m4v",
    "video/3gpp",
)
val IMAGE_EXT_SUPPORT =
    listOf("jpg", "png", "jpeg", "bmp", "webp", "heic", "heif", "gif", "dng", "svg", "ico")
val VIDEO_EXT_SUPPORT = listOf("mp4", "mkv", "webm", "mov", "avi", "wmv", "flv", "m4v", "3gp")

val AUDIO_EXT_SUPPORT = listOf("mp3", "wav", "flac", "aac", "ogg", "wma", "m4a")

fun getMimeType(fileName: String): String {
    return when {
        fileName.endsWith(".html", true) -> "text/html"
        fileName.endsWith(".htm", true) -> "text/html"
        fileName.endsWith(".css", true) -> "text/css"
        fileName.endsWith(".js", true) -> "application/javascript"
        fileName.endsWith(".json", true) -> "application/json"
        fileName.endsWith(".jpg", true) || fileName.endsWith(".jpeg", true) -> "image/jpeg"
        fileName.endsWith(".png", true) -> "image/png"
        fileName.endsWith(".webp", true) -> "image/webp"
        fileName.endsWith(".bmp", true) -> "image/bmp"
        fileName.endsWith(".heic", true) -> "image/heic"
        fileName.endsWith(".heif", true) -> "image/heif"
        fileName.endsWith(".gif", true) -> "image/gif"
        fileName.endsWith(".svg", true) -> "image/svg+xml"
        fileName.endsWith(".dng", true) -> "image/dng"
        fileName.endsWith(".ico", true) -> "image/x-icon"
        fileName.endsWith(".ttf", true) -> "font/ttf"
        fileName.endsWith(".otf", true) -> "font/otf"
        fileName.endsWith(".woff", true) -> "font/woff"
        fileName.endsWith(".woff2", true) -> "font/woff2"
        fileName.endsWith(".map", true) -> "application/json"
        fileName.endsWith(".txt", true) -> "text/plain"
        fileName.endsWith(".xml", true) -> "application/xml"
        fileName.endsWith(".mp4", true) -> "video/mp4"
        fileName.endsWith(".mp3", true) -> "audio/mpeg"
        fileName.endsWith(".mkv", true) -> "video/x-matroska"
        fileName.endsWith(".webm", true) -> "video/webm"
        fileName.endsWith(".mov", true) -> "video/quicktime"
        fileName.endsWith(".avi", true) -> "video/x-msvideo"
        fileName.endsWith(".wmv", true) -> "video/x-ms-wmv"
        fileName.endsWith(".flv", true) -> "video/x-flv"
        fileName.endsWith(".m4v", true) -> "video/x-m4v"
        fileName.endsWith(".3gp", true) -> "video/3gpp"
        fileName.endsWith(".pdf", true) -> "application/pdf"
        else -> "application/octet-stream"
    }
}
